import { IconProps } from "../types";

export const UserIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_812_14404)">
        <circle cx="8.5" cy="8.5" r="8" fill={fillColor ?? "#D9D9D9"} />
        <path
          d="M6.5 5.66805C6.5 4.46613 7.45545 3.5 8.50274 3.5C9.55003 3.5 10.5 4.45463 10.5 5.6623C10.5 6.86997 9.55552 7.87636 8.50274 7.87636C7.44997 7.87636 6.5 6.89872 6.5 5.66805ZM8.50274 8.73898C6.05723 8.73898 4.5 10.4757 4.5 11.7409C4.5 12.2125 4.83996 12.5 5.39925 12.5H11.6008C12.1655 12.5 12.5 12.2125 12.5 11.7409C12.5 10.4757 10.9428 8.73898 8.49726 8.73898H8.50274Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_14404">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
